import {
  TOrderSettingsTabKey,
} from '@/page/orders/order-settings.ts';

const tabs: Record<TOrderSettingsTabKey, string> = {
  attributes: 'Atrybuty',
  tableView: 'Tabela przeglądu',
};
export default {
  tabs,
};
